import {
  SET_COURSES,
} from '../actions/types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_COURSES:
      return [ ...action.payload ];
    default:
      return state;
  }
};
